import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useEmployees = (page = 1, term = null) => useQuery({ queryKey: ['employees', page, term], queryFn: async () => {
    const callback = await API.get(`/employees?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useEmployees